import moment from 'moment';
import React from 'react';
import {
  sortAlphabetically,
  sortNumerically,
  sortByDate,
} from '../utils/utils';
import CallDirection from '../../../../CallHistory/components/CallDirection/CallDirection';
import PhoneNumber from '../../../../../components/PhoneNumber/PhoneNumber';
import ActionRow from '../components/ActionRow/ActionRow';

export const columnKeys = {
  createTime: 'createTime',
  serviceCompany: 'serviceCompany',
  callerId: 'callerId',
  requests: 'requests',
  operator: 'operator.shortName',
  recording: 'recording',
};

const FilterItemContainer = ({ children }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
      {children}
    </div>
  );
};

export const callListColumns = ({ operatorsFilters, companiesFilters }) => [
  {
    key: columnKeys.createTime,
    dataIndex: columnKeys.createTime,
    width: `15%`,
    title: 'Время звонка',
    sorter: (a, b) =>
      sortByDate(a[columnKeys.createTime], b[columnKeys.createTime]),
    render: (createTime) => {
      return <div>{moment(createTime).format('DD.MM.YYYY HH:mm')}</div>;
    },
  },
  {
    key: columnKeys.serviceCompany,
    dataIndex: columnKeys.serviceCompany,
    width: `20%`,
    title: 'УК',
    sorter: (a, b) =>
      sortAlphabetically(
        a[columnKeys.serviceCompany],
        b[columnKeys.serviceCompany]
      ),
    filters:
      companiesFilters?.length > 1
        ? companiesFilters?.map((item) => ({
            ...item,
            text: `${item.name} (${item.count})`,
          }))
        : [],
    onFilter: (value, item) => item[columnKeys.serviceCompany].includes(value),
  },
  {
    key: columnKeys.callerId,
    dataIndex: columnKeys.callerId,
    width: `20%`,
    title: 'Номер',
    sorter: (a, b) =>
      sortNumerically(a[columnKeys.callerId], b[columnKeys.callerId]),
    filters: [
      {
        value: 'in',
        text: (
          <FilterItemContainer>
            <CallDirection direction="in" />
            <span>Входящие</span>
          </FilterItemContainer>
        ),
      },
      {
        value: 'out',
        text: (
          <FilterItemContainer>
            <CallDirection direction="out" />
            <span>Исходящие</span>
          </FilterItemContainer>
        ),
      },
    ],
    onFilter: (value, item) => item?.direction.includes(value),
    render: (_, call) => {
      return (
        <div style={{ display: 'flex', gap: '5px' }}>
          <CallDirection direction={call.direction} />
          <PhoneNumber phoneNumber={call.callerId} />
        </div>
      );
    },
  },
  {
    key: columnKeys.requests,
    dataIndex: columnKeys.requests,
    width: `15%`,
    title: '№ заявки',
    render: (requests) => <div>{requests || '-'}</div>,
  },
  {
    key: columnKeys.operator,
    dataIndex: columnKeys.operator,
    width: `20%`,
    title: 'Оператор',
    sorter: (a, b) =>
      sortAlphabetically(a.operator?.shortName, b.operator?.shortName),
    filters:
      operatorsFilters?.length > 1
        ? operatorsFilters?.map((item) => ({
            ...item,
            text: `${item.name} (${item.count})`,
          }))
        : [],
    onFilter: (value, item) => item.operator?.id?.includes(value),
    render: (operator) => <div>{operator?.shortName || '-'}</div>,
  },
  {
    key: columnKeys.recording,
    width: `10%`,
    title: 'Запись',
    render: (_, call) => <ActionRow call={call} />,
  },
];

export const content = [
  {
    key: columnKeys.createTime,
    title: 'Время звонка',
    render: (call) => (
      <div>{moment(call?.createTime).format('DD.MM.YYYY HH:mm')}</div>
    ),
  },
  {
    key: columnKeys.serviceCompany,
    title: 'УК',
    render: (call) => <div>{call?.serviceCompany || '-'}</div>,
  },
  {
    key: columnKeys.callerId,
    title: 'Номер',
    render: (call) => (
      <div style={{ display: 'flex', gap: '5px' }}>
        <CallDirection direction={call.direction} />
        <PhoneNumber phoneNumber={call.callerId} />
      </div>
    ),
  },
  {
    key: columnKeys.requests,
    title: '№ заявки',
    render: (call) => <div>{call?.requests || '-'}</div>,
  },
  {
    key: columnKeys.operator,
    title: 'Оператор',
    render: (call) => <div>{call?.operator?.shortName || '-'}</div>,
  },
  {
    key: columnKeys.recording,
    title: 'Запись',
    render: (call) => <ActionRow call={call} />,
  },
];
